import { render } from "./ScanReturn.vue?vue&type=template&id=17645d98&ts=true"
import script from "./ScanReturn.vue?vue&type=script&lang=ts"
export * from "./ScanReturn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__